import React from 'react';
import Button from '@mui/material/Button';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';
import { SxProps, Theme } from '@mui/material/styles';
import { colors } from 'app/providers/theme/colors-type';

interface ICustomButton {
    title?: string;
    icon?: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
    leftIcon?: boolean;
    rightIcon?: boolean;
    borderRadius?: string;
    variant?: "text" | "outlined" | "contained";
    handleClick: () => void | Promise<void>;
    width?: string;
    padding?: string;
    minWidth?: string;
    textColor?: string;
    backgroundColor?: string;
    textTransform?: string;
    fontSize?: string;
    gap?: string;
    display?: string;
    alignItems?: string;
    justifyContent?: string;
    border?: string;
    disabled?: boolean;
}

const CustomButton: React.FC<ICustomButton> = ({
    title,
    icon: Icon,
    leftIcon = false,
    rightIcon = false,
    borderRadius = '14px',
    variant = 'outlined',
    handleClick,
    width,
    padding = '0',
    minWidth,
    textColor,
    backgroundColor,
    textTransform = 'none',
    fontSize = '16px',
    gap,
    display,
    alignItems,
    justifyContent,
    border,
    disabled = false
}) => {
    const buttonStyles: SxProps<Theme> = {
        borderRadius,
        width,
        padding,
        minWidth: minWidth as string | undefined,
        color: disabled ?  colors.textGreyDark : textColor,
        backgroundColor: disabled ? colors.textLight : backgroundColor,
        textTransform: textTransform as any,
        fontSize,
        border: border,
        gap,
        display: display as any,
        alignItems,
        justifyContent,
        cursor: disabled ? 'not-allowed' : 'pointer',
        '&.Mui-disabled': {
            color: colors.textGreyDark,
            backgroundColor: colors.textLight,
            borderColor: colors.textLight,
            cursor: 'not-allowed',
            pointerEvents: 'auto',
        },
    };

    return (
        <Button
            variant={variant}
            onClick={handleClick}
            sx={buttonStyles}
            startIcon={leftIcon && Icon ? <Icon /> : undefined}
            endIcon={rightIcon && Icon ? <Icon /> : undefined}
            disabled={disabled}
        >
            {(!leftIcon && !rightIcon && Icon) ? <Icon /> : undefined}
            {title}
        </Button>
    );
};

export default CustomButton;
